export enum MouseButton {
  Other = -1,
  Main = 0,
  Auxiliary = 1,
  Secondary = 2,
}

export function getClickType(event: MouseEvent): MouseButton {
  const buttonClicked = event.which - 1 || event.button;

  if (buttonClicked < 0 || buttonClicked > 2) {
    return MouseButton.Other;
  }

  return buttonClicked;
}
